export const versionKeys = {
  all: ["versions"] as const,
  byProject: (projectId: string) =>
    [...versionKeys.all, "project", projectId] as const,
  detail: (projectId: string, versionId: string) =>
    [...versionKeys.byProject(projectId), versionId] as const,
  diff: (projectId: string, a: string, b: string) =>
    [...versionKeys.byProject(projectId), "diff", a, b] as const,
};
